@if (form) {
  <form [formGroup]="form">
    @if (!isEmailValid || !hasEmail) {
      <div class="orange">
        @if (!hasEmail) {
          <div>
            <p class="orange icon-with-text">
              <mat-icon svgIcon="obs-solid"></mat-icon>
              <span>Bemærk: Vi har ikke registreret en e-mail på Kunden. Brevet bliver udsendt med fysisk post.</span>
            </p>
          </div>
        }
        @if (hasEmail && !isEmailValid) {
          <div>
            <p class="orange icon-with-text">
              <mat-icon svgIcon="obs-solid"></mat-icon>
              <span>Bemærk: kundens email i G4 er ikke gyldig. Ret emailen for at udsende opsigelsesbrev</span>
            </p>
          </div>
        }
      </div>
    }
    <div class="form-row">
      <mat-radio-group formControlName="sendLetter">
        <mat-radio-button [value]="true">Ja</mat-radio-button>
        <mat-radio-button [value]="false">Nej</mat-radio-button>
      </mat-radio-group>
    </div>
    @if (hasEmail) {
      <div>
        <p>Sendes til e-mail: {{ email }}</p>
      </div>
    }
    @if (hasReloadSubscribers) {
      <small>
        Hvis mail er forkert: Du kan rette mail på kunden i G4 og genindlæse
        <a (click)="reload.emit()">her</a>
        .
      </small>
    }
  </form>
}
